<template>
  <div class="upload">
    <slot :files="files" v-if="!showImage" />
    <div class="upload__image" v-if="showImage">
      <div class="info-upload__image">
        <img src="/assets/upload-file.svg" alt="" />
      </div>
      <div class="info-upload__text">
        <p>
          <span>Selecciona</span> o <span>arrastra</span><br />los documentos que deseas cargar.
        </p>
      </div>
    </div>
    <input
      type="file"
      class="upload__item"
      :class="disabled ? 'upload__disabled' : ''"
      :multiple="multiple"
      @input="onInput"
      v-if="resetInput"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: 'Upload',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: [FileList, File, Array],
    fileExtensions: {
      type: Array,
      default: () => [],
    },
    showImage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      files: [],
      resetInput: true,
    };
  },
  methods: {
    onInput(event) {
      const { target } = event;
      if (target.value === '') {
        return;
      }
      if (target.files && (this.multiple ? target.files.length : []) !== 0) {
        if (this.fileExtensions.length !== 0) {
          this.files = [...target.files].filter((x) =>
            this.fileExtensions.includes(this.getFiletype(x))
          );
        } else {
          this.files = target.files;
        }
        if (this.multiple) {
          this.$emit('input', this.files);
        } else {
          this.$emit('input', this.files[0]);
        }

        this.resetInput = false;
        this.$nextTick(() => {
          this.resetInput = true;
        });
      }
    },
    getFiletype(file) {
      const filename = file.name;
      return filename.split('.').pop();
    },
  },
  watch: {
    value(val) {
      this.files = val;
    },
  },
};
</script>

<style lang="scss">
.upload__image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  position: relative;
  i {
    color: #333;
    font-size: 32px;
  }
}
.info-upload__image {
  margin-right: 20px;
}
.info-upload__text {
  span {
    color: #5b89f2;
    font-weight: 600;
  }
}
.upload {
  min-height: 124px;
  background-color: #fbfbfb;
  padding: 8px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #bdc6cc;
  position: relative;
  &__item {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    opacity: 0;
    background-color: transparent;
    cursor: pointer;
    &:hover {
      cursor: pointer;
    }
  }
  &__disabled {
    cursor: not-allowed;
    &:hover {
      cursor: not-allowed;
    }
  }
}
</style>
